/* eslint-disable @typescript-eslint/naming-convention */
import { type CustomNodePosition, type ICustomNodeData, type IService } from '../../shared';
import type { ServiceManager } from '../service-manager';

export class CustomDataService implements IService {
    /** 存储自定义数据 */
    private __customData: Record<string, unknown> = {};

    private __customNode: Set<ICustomNodeData> = new Set();

    private __eventName = 'gs-render-custom-layer';

    constructor(readonly service: ServiceManager) {}

    onInit() {
        this.__customNode.clear();
        this.__emitNodeChange();
    }

    /** 存储自定义数据 */
    setCustomData(key: string, value: unknown) {
        this.__customData[key] = value;
    }

    /** 获取自定义数据 */
    getCustomData<T>(key: string) {
        const data = this.__customData[key];
        return data ? (data as T) : null;
    }

    /**
     * 添加自定义节点
     *
     * @param type - 类型
     * @param data - 数据
     * @param position - 位置
     */
    add(
        frameId: number,
        type: string,
        node: React.ReactNode,
        position: CustomNodePosition = 'bottom',
        autoPosition: boolean = true,
    ) {
        const item = {
            frameId,
            type,
            node,
            position,
            autoPosition,
        };
        this.__customNode.add(item);
        this.__emitNodeChange();
        // console.log('add custom node => ', item);
        return item;
    }

    /** 移除自定义节点 */
    remove(item: ICustomNodeData) {
        this.__customNode.delete(item);
        this.__emitNodeChange();
    }

    /** 监听自定义节点渲染 */
    onNodeChange(callback: (data: ICustomNodeData[]) => void) {
        const handler = this.service.events.on(this.__eventName, callback);
        return () => {
            this.service.events.off(handler);
        };
    }

    /** 获取快捷操作菜单 */
    getNodes() {
        return Array.from(this.__customNode);
    }

    private __emitNodeChange() {
        this.service.events.emit(this.__eventName, this.getNodes());
    }
}
